import Bfs from '@blink-common/component.bfs-utils';

const bfs = new Bfs();

export function httpSafe(val: string) {
  if (location.protocol.indexOf('https') >= 0) {
    return (val + '').replace('http://', 'https://');
  }
  return val;
}

export function bfsSize(src: string, width: number, height?: number, c = 0 as any) {
  return bfs.getImageLink(httpSafe(src || ''), width, height, {
    c,
  });
}

export function timestamp2Timezone(timestamp: number) {
  // timestamp: 接口返回的时间戳（必须转成毫秒级）
  // 目标时区: 东八区
  const timezone = 8
  // 客户端本地时间和格林威治的时间差，单位为分钟
  const offsetGMT = new Date(timestamp).getTimezoneOffset()
  // 换算到目标时区时间
  const targetDate = new Date(timestamp + offsetGMT * 60 * 1000 + timezone * 60 * 60 * 1000)
  // return targetDate.format()
  return targetDate
}

// 时间戳转日期
// 时间戳必须是毫秒
export function timestamp2date(time: number, showYear = true, connector?: string) {
  const date = new Date(timestamp2Timezone(time))
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  if (connector) {
    return showYear ?
      year + connector + month + connector + day :
      month + connector + day
  }
  return showYear ?
    `${year}年${month}月${day}日` :
    `${month}月${day}日`
}